import { FieldType } from '../types/field-type';
import { ConditionalType } from '../types/conditional-type';

export class Field {
  id: string | undefined;
  name: string | undefined;
  description: string | undefined;
  tag: string | null | undefined;
  required: boolean | undefined;
  conditionalType: ConditionalType | null | undefined;
  conditionalTerms: string[] | undefined;
  presented: boolean | undefined;
  type: FieldType | undefined;
  definition: string | undefined;
  columnWidth: number | undefined;
  order: number | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldCustomParameter: any;
}
